import { render, staticRenderFns } from "./ExcuseWaitingDocument.vue?vue&type=template&id=8aa227be&"
import script from "./ExcuseWaitingDocument.vue?vue&type=script&lang=js&"
export * from "./ExcuseWaitingDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports